/*tslint:disable:max-line-length*/
import { HomeMoreInformation } from '@interfaces/cms.interface';


// CMS Mock responses
export const GENERAL_INFO_RESPONSE = {
  data: {
    flotante_url: 'https://tuguiavital.planvital.cl/?s=pensi%C3%B3n',
    mostrar_flotante: false,
    modal_login: false,
    flotante: [{
      id: 1,
      idioma: 'es',
      informacion_general: 1,
      titulo: '¿Quieres saber más sobre tu pensión?',
      bajada: 'Ingresa a Tu Guía Vital e infórmate',
      boton: 'Tu Guía Vital'
    },
    {
      id: 2,
      idioma: 'ht',
      informacion_general: 1,
      titulo: 'Solicitud algo creole',
      bajada: 'una cosa bla creole',
      boton: 'boton creole'
    }],
    traducciones: [{
      id: 1,
      horarios_call_center: '<p>Autoatenci&oacute;n durante las 24 hrs.</p>\n<p>Atenci&oacute;n por ejecutivo de lunes a viernes de 8:45 a 17:30</p>\n<p>Ll&aacute;manos desde fijos o celulares.</p>',
      idioma: 'es',
      informacion_general: 1,
      ingreso_titulo: 'Revisa cuánto dinero tienes en la AFP',
      ingreso_bajada: '<p>Debido a la contingencia, habilitamos la opci&oacute;n para revisar tu saldo y actualizar tus datos, si deseas hacer otros tr&aacute;mites ingresa a la sucursal virtual.</p>'
    }]
  },
  public: true
};
export const FAQ_INFO_RESPONSE = {
  data: [
    {
      codigo: 1,
      faqs: [
        {
          ret_faqs_id: {
            pregunta: 'Si tengo una retención judicial, ¿Cómo puedo conocer el estado de mi retiro del 10%?',
            respuesta: '<p>Sigue los pasos que te indicamos a continuaci&oacute;n:</p>\n<p>1. Ingresa a <a href=\"https://oficinajudicialvirtual.pjud.cl/consulta10.php\" target=\"_blank\" rel=\"noopener\">oficina judicial virtual.</a></p>\n<p>2. Digita tu <strong>RUT</strong> y <strong>N&deg; de serie</strong> de la c&eacute;dula de identidad.</p>\n<p>3. Haz clic en <strong>Consultar</strong>.</p>\n<p>Finalmente, se desplegar&aacute; toda la informaci&oacute;n necesaria para que sepas en qu&eacute; etapa del proceso est&aacute; tu solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con mi solicitud de retiro si fallezco antes del pago?',
            respuesta: '<p>Si el afiliado fallece despu&eacute;s de aceptada su solicitud y antes del pago del monto total del retiro, el saldo pendiente de pago deber&aacute; ser pagado como herencia, a&uacute;n si existieren beneficiarios de pensi&oacute;n de sobrevivencia.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Hasta cuándo se puede solicitar el retiro del 10%?',
            respuesta: '<p>El plazo para hacer la solicitud es hasta el <strong>31 de julio de 2021.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿A través de qué medios puedo solicitar el retiro de los fondos?',
            respuesta: '<p>Hasta el 2 de agosto el proceso <strong>ser&aacute; digital</strong> y los afiliados deber&aacute;n solicitar su retiro a trav&eacute;s de la <strong>p&aacute;gina web de la AFP</strong>, solo con su RUT y el n&uacute;mero de serie del carnet de identidad. A partir de esa fecha, las sucursales de AFP atender&aacute;n a los afiliados que requieran solicitar su retiro de acuerdo con un orden establecido por cada Administradora, con el objetivo de cumplir con las medidas y recomendaciones sanitarias en las sucursales. Adem&aacute;s, los afiliados pueden solicitar el retiro a trav&eacute;s del call center de cada AFP.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué monto se puede retirar?',
            respuesta: '<p>La Ley permite el retiro de <strong>hasta 10% de los fondos ahorrados</strong>. Se establece que <strong>el m&iacute;nimo a retirar ser&aacute; 35 UF</strong> (aproximadamente $1.000.000) y <strong>el m&aacute;ximo 150 UF</strong> ($4.300.000). Si un afiliado tiene menos de 35 UF, podr&aacute; retirar <strong>el total del fondo ahorrado en su cuenta</strong>.</p>\n<p>En la solicitud de retiro, el afiliado deber&aacute; indicar si desea retirar el 100% de lo permitido o un monto menor.</p>\n<p>Valores aproximados y calculados con el valor de la UF vigente al 27 de julio 2020, de $28.671,14</p>\n<p><img src=\"https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/86d4eea0-8ba7-42f4-91c6-86affe116730.png\" alt=\"retiro-faq-1\" width=\"1212\" height=\"408\" /></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes pueden solicitar el retiro de su 10%?',
            respuesta: '<p><strong>Todas las personas que tengan saldo en su cuenta</strong> de capitalizaci&oacute;n individual pueden acceder al retiro. Esto incluye a los <strong>pensionados por vejez, invalidez o sobrevivencia</strong>.</p>\n<p>Adem&aacute;s, este es un <strong>retiro universal</strong>, es decir, que todos los afiliados en las AFP, sin exclusi&oacute;n, pueden optar a esta alternativa. Esto considera a los <strong>trabajadores</strong>, tanto del <strong>sector p&uacute;blico</strong> como del <strong>privado</strong> y tanto a los <strong>chilenos</strong> como <strong>extranjeros.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Todos los pensionados pueden acceder al retiro del 10%?',
            respuesta: '<p>Pueden retirar fondos los pensionados por <strong>vejez, invalidez o sobrevivencia</strong> que reciban su pensi&oacute;n bajo las modalidades de <strong>Renta Temporal o Retiro Programado</strong>, luego del retiro su pensi&oacute;n ser&aacute; recalculada considerando el menor saldo. Las personas que adem&aacute;s de ser afiliadas, sean beneficiarios de una pensi&oacute;n de sobrevivencia podr&aacute;n retirar el 10% del fondo de su cuenta individual para la pensi&oacute;n y adem&aacute;s, podr&aacute;n solicitar el 10% del capital necesario para financiar su pensi&oacute;n de sobrevivencia si as&iacute; lo desean.</p>\n<p>El retiro de fondos es efectivo solo para pensionados que tengan sus ahorros previsionales en una AFP, es decir, quienes reciban una <strong>Renta Vitalicia</strong> de una Compa&ntilde;&iacute;a de Seguros no pueden optar a esta solicitud, a menos que luego de su jubilaci&oacute;n sigan cotizando en una AFP y mantengan fondos en su cuenta.</p>\n<p><img src=\"https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/a2bbf813-dd56-4cbb-a7ad-d5a63c2a8300.png\" alt=\"retiro-faq-2\" width=\"1240\" height=\"564\" /></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se solicita el retiro?',
            respuesta: '<p>El afiliado debe ingresar una <strong>solicitud de retiro</strong> en la <strong>web de la AFP</strong> a la que est&aacute; afiliado. Los afiliados que no sepan en qu&eacute; AFP est&aacute;n, pueden consultarlo en la <a href=\"https://www.spensiones.cl/apps/certificados/formConsultaAfiliacion.php\" target=\"_blank\" rel=\"noopener noreferrer\">Superintendencia de Pensiones</a> o <a href=\"https://www.chileatiende.gob.cl/tramites/3310\" target=\"_blank\" rel=\"noopener noreferrer\">Chile Atiende</a> solo con su RUT.</p>\n<p>En la solicitud de retiro, el afiliado debe indicar sus <strong>datos personales, si desea retirar la totalidad del monto permitido u otro monto</strong>, si tiene deuda por <strong>pensi&oacute;n alimenticia</strong> y la <strong>modalidad de pago</strong> (transferencia a la Cuenta 2, a su cuenta bancaria, cuenta de Caja de Compensaci&oacute;n, cuenta de Cooperativa de Ahorro y Cr&eacute;dito o mediante pagos presenciales a ser retirados en Sencillito, Servipag o vale vista). Por motivos de seguridad, se transferir&aacute; el pago solo a cuentas cuyo RUT de titular sea el RUT del afiliado solicitante. Luego de completar la solicitud, los afiliados recibir&aacute;n un comprobante en el que se indicar&aacute; la fecha y los detalles de la solicitud.</p>\n<p>Los <strong>trabajadores extranjeros que</strong> no tengan su RUT definitivo podr&aacute;n solicitar el retiro con el <strong>NIC (N&uacute;mero Identificatorio para Cotizaci&oacute;n)</strong> junto a su clave de AFP si realizan el tr&aacute;mite de manera remota. De si realizan la solicitud de manera presencial, deber&aacute;n presentar, adem&aacute;s, su pasaporte o documento de identidad del pa&iacute;s de origen.</p>\n<p>Aquellos <strong>afiliados que residan en el extranjero</strong> pueden realizar su solicitud de retiro, a trav&eacute;s de un representante mediante una escritura p&uacute;blica o privada legalizada ante notario o Registro Civil.</p>\n<p>Tres d&iacute;as h&aacute;biles despu&eacute;s de realizar esta solicitud, los afiliados recibir&aacute;n una <strong>respuesta</strong> de aprobaci&oacute;n o rechazo por parte de su administradora. La solicitud podr&iacute;a no ser aprobada si la persona <strong>no tiene saldo en su cuenta individual</strong>.</p>\n<p>En caso de ser aprobada, los solicitantes recibir&aacute;n el primer pago por el <strong>50% del monto total del retiro</strong> en <strong>10 d&iacute;as h&aacute;biles</strong> desde la solicitud. En tanto, el segundo pago se realizar&aacute; dentro de 30 d&iacute;as h&aacute;biles despu&eacute;s del primer pago.</p>\n<p><img src=\"https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/22d45d4e-4252-450c-8196-36f6b2349726.png\" alt=\"retiro-faq-3\" width=\"1024\" height=\"573\" /></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo es el formulario que tendré que llenar para solicitar el retiro de los fondos?',
            respuesta: '<p>El formulario tiene un formato &uacute;nico de solicitud en el cual se requerir&aacute; la misma informaci&oacute;n a los afiliados: n&uacute;mero de c&eacute;dula de identidad y su serie o n&uacute;mero de documento, domicilio completo (opcional), tel&eacute;fono y correo electr&oacute;nico, adem&aacute;s de las respectivas instrucciones de llenado y la modalidad de pago, pudiendo seleccionar la transferencia a la cuenta de ahorro voluntario (cuenta 2) en la AFP donde est&aacute; efectuando el retiro (si no posee una cuenta 2 se crear&aacute; una autom&aacute;ticamente), el dep&oacute;sito en una cuenta bancaria o de instituciones financieras, incluyendo cooperativas de ahorro y cr&eacute;dito, y cuentas de provisi&oacute;n de fondos en cajas de compensaci&oacute;n, debiendo para estos efectos informar el N&deg; de cuenta, Tipo de cuenta y nombre de la entidad.</p>\n<p>En caso de pago de efectivo, se puede incorporar servicios como Servipag o Sencillito. El pago a trav&eacute;s de vale vista solo estar&aacute; disponible para aquellos que no cuenten con cuenta bancaria ni con cuentas en cajas de compensaci&oacute;n o en cooperativas.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se puede usar una cuenta de un tercero o cuentas bipersonales?',
            respuesta: '<p>Las administradoras no est&aacute;n autorizadas a depositar en cuentas bipersonales, ni en cuentas digitales con proceso de apertura no presenciales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuál es el plazo para recibir el pago?',
            respuesta: '<p>La ley establece que <strong>el primer pago</strong> debe entregarse en un <strong>plazo m&aacute;ximo de 10 d&iacute;as h&aacute;biles</strong> contado desde la fecha de la presentaci&oacute;n de la solicitud de retiro a la administradora. El <strong>segundo pago</strong>, en tanto, debe ser pagada <strong>en el plazo m&aacute;ximo de 30 d&iacute;as h&aacute;biles</strong> contado desde la fecha de pago del primer pago.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si retiro 35 UF o menos, ¿en cuántos pagos me pagarán mis fondos?',
            respuesta: '<p>En estos casos, el pago se har&aacute; sobre el total del saldo disponible, <strong>en un pago</strong> y dentro de los 10 d&iacute;as h&aacute;biles siguientes a la fecha de la presentaci&oacute;n de la solicitud de retiro.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿El trámite tiene algún costo para el afiliado?',
            respuesta: '<p>El proceso de retiro <strong>es gratuito</strong> para el afiliado. No tiene ning&uacute;n costo. Adem&aacute;s, los afiliados que opten por recibir su 10% en la Cuenta 2 no pagar&aacute;n comisi&oacute;n por la administraci&oacute;n de este monto.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se necesita la clave de AFP para realizar el proceso de retiro?',
            respuesta: '<p>No. El proceso online de solicitud de retiro <strong>no requiere clave para realizarlo</strong>. La clave solo ser&aacute; necesaria para verificar la identidad de los extranjeros que a&uacute;n no tienen RUT definitivo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿A qué cuentas pueden transferirse los fondos?',
            respuesta: '<p>El pago se har&aacute; v&iacute;a transferencia a una <strong>Cuenta de Ahorro Voluntario</strong> <strong>(Cuenta 2)</strong>, a una <strong>cuenta bancaria</strong>, de <strong>Caja de Compensaci&oacute;n</strong> o de <strong>Cooperativa de Ahorro y Cr&eacute;dito</strong>, para lo que el afiliado deber&aacute; informar el n&uacute;mero y tipo de cuenta adem&aacute;s del nombre de la entidad que la administra. El afiliado tambi&eacute;n podr&aacute;́ optar por el pago mediante un <strong>vale vista</strong> nominativo para ser cobrado en una entidad financiera o el pago presencial a ser retirado en Sencillito o Servipag. Los afiliados que no tengan abierta una Cuenta 2, pueden recibir los fondos igualmente en ella, ya que <strong>se abrir&aacute; autom&aacute;ticamente</strong> con el dep&oacute;sito del retiro. El monto del retiro no estar&aacute; afecto cobro de comisiones por administraci&oacute;n.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Hay que pagar impuestos, comisiones o descuentos por retirar fondos?',
            respuesta: '<p>El dinero retirado de la AFP no paga <strong>ning&uacute;n tipo de impuestos o comisiones por parte de las administradoras</strong>. El monto <strong>no ser&aacute; objeto de retenci&oacute;n</strong> o descuento salvo en el caso de adeudar pensi&oacute;n de alimentos o compensaci&oacute;n econ&oacute;mica de divorcio, en ese caso el monto adeudado ser&aacute; retenido y la AFP lo traspasar&aacute; al demandante.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué necesito tener para hacer la solicitud de retiro de fondos?',
            respuesta: '<p>Para realizar la solicitud, se requiere solo el RUT, el n&uacute;mero de serie del documento de identidad y conocer la AFP en que est&aacute; afiliado. Los <strong>trabajadores extranjeros</strong> que <strong>no tengan su RUT</strong> definitivo podr&aacute;n solicitar el retiro con el <strong>NIC (N&uacute;mero Identificatorio para Cotizaci&oacute;n)</strong> junto a su <strong>clave de AFP</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se fiscalizará este proceso?',
            respuesta: '<p>La Superintendencia de Pensiones es el regulador de este proceso.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se puede solicitar el retiro a otro agente distinto a la AFP?',
            respuesta: '<p>No. El retiro de fondos solo se puede retirar a trav&eacute;s de la AFP de cada afiliado. No se requieren intermediarios. Por eso, no entregues tus datos a ninguna persona que te contacte ofreciendo asesor&iacute;a o mediaci&oacute;n. Evita fraudes.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Los valores que me informa la AFP son los definitivos?',
            respuesta: '<p>Los montos por retirar son referenciales y expresados en cuotas y pesos, a la fecha de la comunicaci&oacute;n que realice la administradora al afiliado. Estos valores pueden sufrir variaciones de acuerdo con las fluctuaciones que experimente el valor de las cuotas de los Fondos de Pensiones producto del valor de sus inversiones.</p>\n<p>Adem&aacute;s, previo a confirmar la solicitud de retiro de fondos, el afiliado debe confirmar su conocimiento respecto de que el monto del retiro tendr&aacute; un impacto negativo en el monto de su pensi&oacute;n futura.</p>\n<p>Al momento de determinar el monto en pesos del retiro, las administradoras considerar&aacute;n el valor cuota del d&iacute;a h&aacute;bil ante precedente a la del pago.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo me informa la AFP de los avances de mi solicitud?',
            respuesta: '<p>Cada administradora comunicar&aacute; de manera oficial a trav&eacute;s de correo electr&oacute;nico y celular del afiliado.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo retirar menos del 10% que aprobó la ley?',
            respuesta: '<p>La ley establece que, al llenar el formulario de solicitud, el afiliado debe informar si desea retirar el monto m&aacute;ximo permitido (100%). Si la persona selecciona la opci&oacute;n NO, se deber&aacute; permitir el ingreso del porcentaje de retiro deseado en un rango de 1% a 99%. Es necesario recordar, que en caso de que el afiliado opte por un porcentaje menor al 100%, &eacute;ste no podr&aacute; efectuar en el futuro un nuevo retiro por el porcentaje remanente.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si quiero anular mi solicitud de retiro?',
            respuesta: '<p>Podr&aacute;s anular tu solicitud de retiro hasta 4 d&iacute;as despu&eacute;s desde la fecha que hiciste el tr&aacute;mite y puedes hacerlo directamente en nuestra p&aacute;gina web. <a href=\"/${getCancelRoute(MAIN_ROUTES.FIRST_WITHDRAWAL)}\">Ingresa aqu&iacute;</a> y completa los datos.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa en el caso de que un afiliado retire su 10% y tenga deuda de pensión alimenticia?',
            respuesta: '<p>Los afiliados que retiren el 10% de su ahorro previsional y tengan deuda de pensi&oacute;n alimenticia deber&aacute;n informarlo en la solicitud de retiro. Las Administradoras que reciban la liquidaci&oacute;n de deuda por pensi&oacute;n alimenticia y su respectiva sentencia, retendr&aacute;n automaticamente el monto adeudado y se traspasar&aacute; a la parte demandante. De existir diferencias, deber&aacute; pagarlas directamente el afiliado y si el afiliado no solicita el retiro de sus fondos la parte demandante no recibir&aacute; el pago de la deuda.</p>\n<p>La parte demandante puede revisar en la p&aacute;gina web del Poder Judicial, <a href=\"http://www.pjud.cl\">www.pjud.cl</a> (secci&oacute;n Consulta Unificada de Causas y luego, Causas de Familia) con el n&uacute;mero de la causa, el monto total adeudado.</p>\n<p><strong>Por ejemplo, si un afiliado solicita $1.000.000 de sus ahorros previsionales y tiene una deuda de $100.000 por pensi&oacute;n alimenticia, el afiliado recibir&aacute; $900.000 y su demandante los $100.000 adeudados.</strong></p>\n<p><img src=\"https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/87a97470-d5ff-40e7-b0e3-0d8ef0b0675d.png\" alt=\"retiro-faq-4\" width=\"600\" height=\"432\" /></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se están preparando las administradoras para cumplir con el pago del 10%?',
            respuesta: '<p>La Superintendencia de Pensiones establece que todas las administradoras deben capacitar al personal encargado de la atenci&oacute;n a afiliados en el paso a paso del proceso de retiro de fondos, procurar la estabilidad de los servicios web para evitar saturaci&oacute;n, implementar metodolog&iacute;as para la administraci&oacute;n eficiente de filas de espera, optimizar la atenci&oacute;n en sucursales, mantener el horario de atenci&oacute;n habitual incluso en las comunas en cuarentena.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Funcionará la atención por call center?',
            respuesta: '<p>S&iacute;. Las administradoras incluso pueden reforzar con nueva fuerza laboral y con servicios externos, de manera de atender a afiliados y beneficiarios.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se puede hacer la solicitud a través de call center?',
            respuesta: '<p>S&iacute;. En estos casos el formulario es el mismo al dispuesto en las plataformas digitales y las conversaciones deben ser grabadas.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Si soy afiliado de nacionalidad extranjera, ¿qué necesito para pedir mi retiro de fondos?',
            respuesta: '<p><strong>En caso de hacerlo de manera online, los trabajadores extranjeros deben ingresar su Rut y n&uacute;mero de serie de su c&eacute;dula de identidad. En los casos que</strong> no tengan su RUT definitivo podr&aacute;n solicitar el retiro con el <strong>NIC (N&uacute;mero Identificatorio para Cotizaci&oacute;n) junto a su clave de AFP.</strong></p>\n<p>Para aquellos que lo pedir&aacute;n de manera presencial y no tienen c&eacute;dula de identidad, deben hacerlo con pasaporte o documento de identidad de su pa&iacute;s de origen. En este caso, el trabajador extranjero debe presentar el mismo documento que registr&oacute; en la AFP al momento de definirse el NIC para el pago de cotizaciones.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se puede pedir el retiro a través de un mandato notarial?',
            respuesta: '<p>S&oacute;lo en aquellos casos que se pidan de manera presencial. El representante debe estar autorizados ante Notario o Registro Civil. Tambi&eacute;n se autorizan representantes con firma electr&oacute;nica avanzada o simple, de acuerdo con la ley N&deg; 19.799, con los debidos resguardos para evitar la ocurrencia de fraudes.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si tengo mi ahorro en distintos multifondos?',
            respuesta: '<p>El retiro se efectuar&aacute; de manera proporcional respecto del saldo mantenido en cada fondo a la fecha de ingreso de la solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se garantiza el valor cuota del retiro?',
            respuesta: '<p>Cuando la administradora valida la solicitud, se deja retenido el n&uacute;mero de cuotas necesarias para el pago del retiro solicitado por el afiliado.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si una persona fallece mientras espera el pago de sus fondos?',
            respuesta: '<p>Si la fecha de pago est&aacute; pendiente, la administradora deber&aacute; suspenderlo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué sucede si un afiliado que pida el retiro tiene pendiente una compensación por divorcio?',
            respuesta: '<p>En caso de que la administradora sea notificada de la sentencia judicial que ordene el pago de compensaci&oacute;n econ&oacute;mica deber&aacute; descontar dicho valor del monto total de retiro. Si la notificaci&oacute;n llega despu&eacute;s del primer pago, se descontar&aacute; del saldo pendiente.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Los beneficiarios de pensión de sobrevivencia acceden a este retiro?',
            respuesta: '<p>Los menores de 18 a&ntilde;os que sean beneficiarios de pensi&oacute;n de sobrevivencia s&iacute; pueden acceder a este retiro. Los hijos de un causante mayor de 18 a&ntilde;os y menores de 24 a&ntilde;os que no mantengan vigente la calidad de estudiante no podr&aacute;n efectuar el retiro.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Los menores de 18 años que tengan cuenta de afiliado voluntario o cuenta obligatoria pueden hacer el retiro?',
            respuesta: '<p>S&iacute;, a trav&eacute;s de quien tenga la patria potestad, que corresponde a ambos padres.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son las medidas de seguridad para evitar fraude en el retiro de fondos?',
            respuesta: '<p>El retiro de fondos ser&aacute; depositado a una cuenta cuyo RUT deber&aacute; ser el mismo del afiliado que solicita el retiro. Esto se suma, adem&aacute;s, a que no se permite el dep&oacute;sito de fondos a cuentas bipersonales (con m&aacute;s de un titular) ni en cuentas digitales con procesos de apertura no presenciales. De lo contrario, la solicitud ser&aacute; rechazada.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Recibes algún beneficio de seguridad social en el extranjero?',
            respuesta: '<p>Si registras cotizaciones en alguno de los pa&iacute;ses donde Chile mantiene vigente un convenio de Seguridad Social y retiras el 10% de tus fondos, podr&iacute;as dejar de recibir el beneficio, debido a que los periodos cotizados en Chile no se sumar&iacute;an al total de periodos exigidos para acceder al beneficio.</p>\n<p>El retiro del 10% podr&iacute;a afectar tambi&eacute;n a quienes soliciten una pensi&oacute;n o beneficio a futuro en los pa&iacute;ses donde Chile tiene un convenio de Seguridad Social.</p>'
          }
        }
      ]
    },
    {
      codigo: 2,
      faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes podrán solicitar el segundo retiro del 10%?',
            respuesta: '<p>Los <strong>afiliados a una AFP que est&eacute;n en Chile o en el extranjero,</strong> y que tengan saldo en sus cuentas. As&iacute; tambi&eacute;n los beneficiarios por pensi&oacute;n de sobrevivencia y los pensionados por renta temporal o retiro programado (vejez, vejez anticipada o invalidez).</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si ya realicé mi primer retiro, ¿Puedo solicitar el segundo?',
            respuesta: '<p>S&iacute;, mientras tengas saldo en tu cuenta obligatoria o voluntaria.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si aún no he realizado el primer retiro?',
            respuesta: '<p>Ambos retiros <strong>son independientes entre s&iacute;</strong>. Puedes solicitar el segundo sin haber hecho el proceso del primero, o viceversa.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes no podrán solicitar el segundo retiro del 10%',
            respuesta: '<p>Quedan inhabilitados de solicitar el segundo retiro quienes tengan <strong>altos cargos p&uacute;blicos y de gobierno</strong> (Presidente, ministros, subsecretarios, senadores y diputados).</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿En qué fecha comienza el segundo retiro?',
            respuesta: '<p>Podr&aacute;s solicitar tu 2do retiro del 10% a partir del <strong>jueves 10 de diciembre de 2020</strong>, a las 9:00 hrs. Privilegia nuestros canales digitales para hacer tu solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo sé cuánto dinero tengo ahorrado?',
            respuesta: '<p>Para consultar tu saldo, te aconsejamos escribirnos por WhatsApp al <a href=\"https://api.whatsapp.com/send?phone=56222645200&amp;text=Hola\" target=\"_blank\" rel=\"noopener\">+56 2 22645200</a>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo solicitar el 2do retiro en una cuenta distinta a la que ocupé en el primero?',
            respuesta: '<p>S&iacute;, puedes solicitar el segundo retiro en <strong>otra cuenta bancaria que sea tuya</strong> y no de una tercera persona.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué ocurre con mi pensión si hago el retiro?',
            respuesta: '<p>Si haces el retiro, <strong>podr&iacute;a disminuir el monto de tu pensi&oacute;n</strong> a futuro porque &eacute;sta se construye con tus aportes previsionales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con mi pensión después de retirar mis ahorros?',
            respuesta: '<p>Si se pension&oacute; bajo la modalidad de retiro programado, <strong>la pensi&oacute;n se recalcular&aacute;</strong> considerando el menor saldo de la Cuenta Obligatoria. Si <strong>retira el monto total</strong> de los ahorros, <strong>podr&iacute;a quedarse sin pensi&oacute;n</strong> en caso de no tener acceso a los beneficios del Pilar Solidario.<br />Si se pension&oacute; por vejez, puede acceder a estos beneficios si tiene 65 a&ntilde;os o m&aacute;s y cumple con los requisitos de focalizaci&oacute;n y residencia.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Los beneficiarios de pensión de sobrevivencia mayores de 18 años y menores de 24 años podrán acceder a este retiro?',
            respuesta: '<p>S&iacute;, siempre que est&eacute;n estudiando en una instituci&oacute;n t&eacute;cnica o superior perteneciente al Ministerio de Educaci&oacute;n.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con los hijos beneficiarios de pensión de sobrevivencia menores de 18 años?',
            respuesta: '<p>El <strong>responsable legal del menor</strong> podr&aacute; solicitar el segundo retiro y el pago se realizar&aacute; a su nombre.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son los montos de retiro?',
            respuesta: '<p>Al igual que el primer retiro, el <strong>monto m&iacute;nimo ser&aacute; de 35 UF</strong> (cerca de $1 mill&oacute;n) y <strong>m&aacute;ximo 150 UF</strong> (cerca de $4.3 millones).<br />Si el saldo es <strong>inferior a 35 UF</strong>, se podr&aacute; retirar <strong>el total de los ahorros.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se hará el pago?',
            respuesta: '<p>1. La <strong>primera cuota del 50%</strong> se pagar&aacute; en un plazo m&aacute;ximo de <strong>10 d&iacute;as h&aacute;biles </strong>desde que hiciste la solicitud. 2. La <strong>segunda cuota del 50%</strong> restante se pagar&aacute; en un plazo m&aacute;ximo de <strong>10 d&iacute;as h&aacute;biles </strong> despu&eacute;s del primer pago.<br />Para montos <strong>iguales o inferiores a 35 UF</strong>, el pag&oacute; se har&aacute; en <strong>una sola cuota</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo solicito mi 1er y 2do retiro?',
            respuesta: '<p>Para solicitar tu <strong>primer retiro</strong> de fondos, haz <a href=\"${MAIN_ROUTES.FIRST_WITHDRAWAL}\">clic aqu&iacute;</a>.<br />Para solicitar tu <strong>segundo retiro</strong> de fondos, haz <a href=\"${MAIN_ROUTES.SECOND_WITHDRAWAL}\">clic aqu&iacute;</a>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Dónde puedo revisar en qué AFP estoy?',
            respuesta: '<p>Ingresa al sitio web de la <a href=\"https://www.spensiones.cl/apps/certificados/formConsultaAfiliacion.php\">Superintendencia de Pensiones</a> para saber en qu&eacute; AFP est&aacute;s afiliado.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con los deudores de pensión de alimentos en este segundo retiro?',
            respuesta: '<p>Se <strong>aprob&oacute; el retiro forzoso</strong> para quienes tengan deudas por pensi&oacute;n de alimentos.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Desde qué fecha se podrá hacer esta solicitud?',
            respuesta: '<p>Desde el <strong>jueves 10 de diciembre</strong> ,a las 9:00 hrs. Durante dos semanas s&oacute;lo se podr&aacute; hacer la solicitud en <strong>retirounico.planvital.cl</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuál es el plazo para solicitar el Segundo Retiro?',
            respuesta: '<p>Al igual que el primer retiro, la solicitud se podr&aacute; hacer <strong>durante 365 d&iacute;as despu&eacute;s</strong> de publicada la reforma en el Diario Oficial.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo solicitar mi 10% a través de un tercero?',
            respuesta: '<p>S&iacute;, a trav&eacute;s de un <strong>representante ante notario</strong>. Si es una escritura privada, se requiere la firma autorizada por Notario u Oficial del Registro Civil.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuándo me informarán el resultado de mi solicitud?',
            respuesta: '<p>La AFP informar&aacute; el resultado de la solicitud (apruebo o rechazo) en un <strong>plazo de 4 d&iacute;as h&aacute;biles</strong>, desde la fecha de la solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son las formas de pago?',
            respuesta: '<p>Las formas de pago son:<br /><br /><strong>Transferencia a la Cuenta de Ahorro Voluntario o Cuenta Bancaria</strong> de instituciones financieras. Se incluyen tambi&eacute;n las <strong>Cooperativas de Ahorro y Cr&eacute;dito o cuentas de Cajas de Compensaci&oacute;n</strong>, cuyo titular sea el afiliado o beneficiario.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son las alternativas de pago del 2do 10% desde el extranjero?',
            respuesta: '<p>El segundo retiro del 10% de los fondos previsionales <strong>a&uacute;n no est&aacute; disponible</strong>. Podr&aacute;s solicitarlo en <a href=\"https://retirounico.planvital.cl\">retirounico.planvital.cl</a> a contar del <strong>jueves 10 de Diciembre</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si soy extranjero y no tengo el carnet vencido, ¿Cómo hago la solicitud?',
            respuesta: '<p>El segundo retiro del 10% de los fondos previsionales <strong>a&uacute;n no est&aacute; disponible</strong>. Podr&aacute;s solicitarlo en <a href=\"https://retirounico.planvital.cl\">retirounico.planvital.cl</a> a contar del <strong>jueves 10 de Diciembre</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo será el pago de impuestos?',
            respuesta: '<p>El impuesto s&oacute;lo se <strong>aplicar&aacute; a rentas superiores a $1.500.000 brutos</strong>. Si la solicitud de retiro se realiza a partir del 2021, el pago de impuestos se aplicar&aacute; en la operaci&oacute;n renta de 2022.<br />Revisa este ejemplo para que sepas de cu&aacute;nto ser&aacute; el impuesto que deber&aacute;s pagar seg&uacute;n tu sueldo y monto de retiro.</p>\n<table>\n<thead>\n<tr>\n<th>Sueldo mensual</th>\n<th>Monto de retiro en la AFP</th>\n<th>Impuesto</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>$1,5 mill&oacute;n</td>\n<td>$1 mill&oacute;n</td>\n<td>$94.532</td>\n</tr>\n<tr>\n<td>$1,5 mill&oacute;n</td>\n<td>$2 mill&oacute;n</td>\n<td>$174.532</td>\n</tr>\n<tr>\n<td>$1,5 mill&oacute;n</td>\n<td>$3 mill&oacute;n</td>\n<td>$254.532</td>\n</tr>\n<tr>\n<td>$1,5 mill&oacute;n</td>\n<td>$4,3 mill&oacute;n</td>\n<td>$358.532</td>\n</tr>\n<tr>\n<td>$3 mill&oacute;n</td>\n<td>$4,3 mill&oacute;n</td>\n<td>$656.253</td>\n</tr>\n<tr>\n<td>$5 mill&oacute;n</td>\n<td>$4,3 mill&oacute;n</td>\n<td>$1.607.520</td>\n</tr>\n<tr>\n<td>$6 mill&oacute;n</td>\n<td>$4,3 mill&oacute;n</td>\n<td>$1.830.292</td>\n</tr>\n</tbody>\n</table>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Es posible solicitar el 2do retiro si mi cédula de identidad está bloqueada o vencida?',
            respuesta: '<p>Podr&aacute;s solicitar tu <strong>2do retiro del 10%</strong>, ya que en estos casos la validaci&oacute;n de los datos se har&aacute; con tus claves vigentes de la AFP.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo corregir los datos de mi solicitud una vez hecha?',
            respuesta: '<p>S&iacute;, podr&aacute;s anular tu solicitud dentro de <strong>2 d&iacute;as h&aacute;biles</strong> en <a href=\"${getCancelRoute(MAIN_ROUTES.SECOND_WITHDRAWAL)}\">https://retirounico.planvital.cl/segundo-retiro/anular-solicitud</a></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué puedo hacer si la solicitud es rechazada?',
            respuesta: '<p>Te informaremos el motivo de rechazo dentro de <strong>4 d&iacute;as h&aacute;biles</strong> desde que hiciste la solicitud. Despu&eacute;s de eso, podr&aacute;s ingresar una nueva solicitud en <a href=\"${MAIN_ROUTES.HOME_LANDING}\">retirounico.planvital.cl</a></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo solicitar en simultáneo el 1er y 2do retiro?',
            respuesta: '<p>S&iacute;, puedes solicitar ambos retiros. Para eso debes completar los formularios de cada proceso <strong>(1er y 2do retiro)</strong> desde la web.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si me cambio de AFP justo en este momento, ¿Dónde debo realizar la solicitud de retiro?',
            respuesta: '<p>Si te cambias a otra AFP, tendr&aacute;s que hacer la solicitud en la nueva administradora. Recuerda que un proceso de traspaso demora alrededor de <strong>30 d&iacute;as</strong>, tiempo en que no podr&aacute;s hacer otra solicitud o tr&aacute;mite hasta que la nueva AFP reciba los saldos de tu cuenta.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si elijo depósito en Cuenta 2 como medio de pago, ¿Hay algún cobro de comisiones?',
            respuesta: '<p>Si elegiste la Cuenta 2 como medio de pago de tu retiro del 10% no habr&aacute; cobro de comisiones.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿En qué consiste la Cuenta de Ahorro Voluntario (Cuenta 2)?',
            respuesta: '<p>Es una cuenta que te permite ahorrar para cumplir tus objetivos de corto o mediano plazo.<br /><br />Con ella puedes:<br /><br />- Realizar 24 giros en el a&ntilde;o, sin costo.<br /><br />- Depositar lo que t&uacute; desees, a partir de $2.000<br /><br />- Mantener ese ahorro para tu futura pensi&oacute;n</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo puedo retirar mi dinero desde la Cuenta 2?',
            respuesta: '<p>Puedes transferir a otra cuenta bancaria en Chile, donde seas titular. Es importante no ingresar una cuenta bipersonal, ya que de lo contrario ser&aacute; rechazada.</p>\n<p>Puedes pedir tambi&eacute;n pago en efectivo o dep&oacute;sito directo en nuestra red de sucursales. Si es en efectivo, el monto m&aacute;ximo de retiro es de $100.000. Si prefieres transferencia, el dep&oacute;sito se realizar&aacute; al 10&deg; d&iacute;a h&aacute;bil desde la fecha de la solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si elijo depósito en mi Cuenta 2, ¿Tengo que pagar impuestos?',
            respuesta: '<p>El impuesto se paga s&oacute;lo por la rentabilidad que genera el dep&oacute;sito del 2do retiro del 10%.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Recibes algún beneficio de seguridad social en el extranjero?',
            respuesta: '<p>Si registras cotizaciones en alguno de los pa&iacute;ses donde Chile mantiene vigente un convenio de Seguridad Social y retiras el 10% de tus fondos, podr&iacute;as dejar de recibir el beneficio, debido a que los periodos cotizados en Chile no se sumar&iacute;an al total de periodos exigidos para acceder al beneficio.</p>\n<p>El retiro del 10% podr&iacute;a afectar tambi&eacute;n a quienes soliciten una pensi&oacute;n o beneficio a futuro en los pa&iacute;ses donde Chile tiene un convenio de Seguridad Social.</p>'
          }
        }
      ]
    },
    {
      codigo: 3,
      faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes pueden acceder al 3er retiro?',
            respuesta: '<p>Tienen derecho a solicitar el 3er retiro del 10% los <strong>afiliados o pensionados por Retiro Programado o Renta Temporal</strong> que est&eacute;n en Chile o en el extranjero (incluido quienes hayan obtenido el beneficio de pensi&oacute;n Anticipada por Enfermedad) que tengan saldo en sus cuentas individuales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuánto dinero podré retirar?',
            respuesta: '<p>La Ley permite el retiro de <strong>hasta 10% de los fondos ahorrados</strong>. Se establece que <strong>el m&iacute;nimo a retirar ser&aacute; 35 UF</strong> (aproximadamente $1.000.000) y <strong>el m&aacute;ximo 150 UF</strong> ($4.300.000). Si un afiliado tiene menos de 35 UF, podr&aacute; retirar <strong>el total del fondo ahorrado en su cuenta</strong>.</p>\n<p>En la solicitud de retiro, el afiliado deber&aacute; indicar si desea retirar el 100% de lo permitido o un monto menor.</p>\n<p>Valores aproximados y calculados con el valor de la UF vigente al 3 de mayo de 2021, de $29.505,91</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuál es el plazo para solicitar el 3er retiro?',
            respuesta: '<p>El plazo para realizar la solicitud de retiro es de 365 d&iacute;as desde el <strong>lunes 3 de mayo de 2021</strong>, desde las 9:00 horas. Es decir, si un afiliado no necesita hacer el retiro de forma inmediata, tendr&aacute; plazo de un a&ntilde;o para hacerlo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuándo se hará el pago?',
            respuesta: '<p>Te informaremos si tu solicitud fue aprobada o rechazada en un plazo de cuatro d&iacute;as h&aacute;biles contados desde el ingreso de la solicitud. En caso de ser aprobada, tu pago estar&aacute; disponible en <strong>15 d&iacute;as h&aacute;biles</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Por qué medios se podrá hacer la solicitud?',
            respuesta: '<p>Podr&aacute;s hacer tu solicitud a trav&eacute;s de nuestros canales: <strong>sitio web <a href=\"https://planvital.cl\">planvital.cl</a>, Contact Center 800 072 072 y en nuestras sucursales</strong>. No obstante, y para resguardar tu salud, privilegia nuestros canales digitales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Los trabajadores a honorarios, ¿Pueden solicitar el 3er retiro?',
            respuesta: '<p>S&iacute;, pueden hacer el tercer retiro los trabajadores a honorarios, dado que tiene un car&aacute;cter universal al igual que los anteriores. El fondo retirado, eso s&iacute;, incluye el monto del Seguro de Invalidez y Sobrevivencia (SIS), que se destina a financiar este seguro, el cual protege a los trabajadores y a sus familias con una Pensi&oacute;n de Sobrevivencia en caso de fallecimiento.<br /><br />Los trabajadores a honorarios que retiren parte o la totalidad de su monto podr&iacute;an quedar sin cobertura o con una cobertura menor del SIS.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Tendré que pagar impuestos por este tercer retiro?',
            respuesta: '<p>No. Este tercer retiro es <strong>libre del pago de impuestos</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿En qué consiste este 3er retiro del 10%?',
            respuesta: '<p>Este proyecto permite a los afiliados a una AFP que est&eacute;n en Chile o en el extranjero, retirar hasta el 10% de sus ahorros previsionales.<br /><br />Las &uacute;nicas personas que no tienen la posibilidad de solicitar sus fondos son aquellas que se encuentren dentro del art&iacute;culo 38 bis de la Constituci&oacute;n (Presidente de la Rep&uacute;blica, senadores, diputados, ministros, subsecretarios, gobernadores regionales, delegados presidenciales regionales y provinciales, salvo quienes hayan sido contratados a honorarios y que est&eacute;n a cargo de asesorar a las autoridades citadas).</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuál es el plazo para conocer la respuesta a mi solicitud?',
            respuesta: '<p>El plazo m&aacute;ximo establecido por normativa para saber si la solicitud fue aprobada o rechazada es de <strong>4 d&iacute;as h&aacute;biles despu&eacute;s de haberla ingresado, sin contar fin de semanas ni tampoco festivos.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Mi solicitud podría ser rechazada y en qué casos?',
            respuesta: '<p>La solicitud puede ser rechazada en los siguientes casos:</p>\n<ol>\n<li>Error al ingresar los datos</li>\n<li>Cuenta bancaria bipersonal, es decir, con m&aacute;s de un titular</li>\n<li>Cuenta bancaria de un tercero a una cuenta digital, cuya apertura no fue presencial</li>\n<li>Problemas con la C&eacute;dula de Identidad, por ejemplo, que est&eacute; bloqueada al momento de hacer la solicitud.</li>\n</ol>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué puedo hacer si mi solicitud fue rechazada?',
            respuesta: '<p>Si tu solicitud fue rechazada por alguno de los motivos anteriormente mencionados, <strong>puedes ingresar una nueva solicitud en <a href=\"https://retirounico.planvital.cl\">retirounico.planvital.cl</a></strong>, revisando que tus datos sean los correctos.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son los medios de pago para recibir el depósito por el 3er retiro?',
            respuesta: '<p>Puedes solicitar transferencia a una <strong>Cuenta de Ahorro Voluntario (Cuenta 2), a una cuenta bancaria de Cooperativa de Ahorro y Cr&eacute;dito</strong>. Si esta ser&aacute; tu elecci&oacute;n, debes informar el n&uacute;mero y tipo de cuenta, adem&aacute;s del nombre de la entidad administradora.<br /><br />Los afiliados que no posean una Cuenta 2, se les abrir&aacute; una de forma autom&aacute;tica sin costo ni cobro de comisiones.<br /><br />En el caso de los afiliados sin una cuenta bancaria que no quieran transferir su retiro a la Cuenta 2, podr&aacute;n optar por otros medios de pago que ser&aacute;n informados oportunamente cuando la solicitud haya sido aprobada.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿El monto informado en la solicitud podría variar?',
            respuesta: '<p>Los valores son estimativos y est&aacute;n representados en pesos y calculados a una cierta fecha, seg&uacute;n las cuotas que posee el afiliado en los fondos donde se encuentra. Ese saldo puede registrar variaciones que dependen del valor cuota del fondo.<br /><br />El valor cuota, adem&aacute;s, depende de las valorizaciones de las inversiones y su evoluci&oacute;n en el tiempo en los mercados financieros nacionales y globales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Puedo solicitar el tercer retiro del 10% sin haber solicitado el 1ero y tampoco el 2do?',
            respuesta: '<p>S&iacute;, ya que son procesos completamente diferentes. <strong>No es requisito haber solicitado algunos de los retiros para acceder al tercero.</strong> No obstante, los plazos para quienes a&uacute;n no han solicitado el primer retiro de fondos caduca el 31 de julio de 2021, mientras que para el segundo retiro el plazo se cumple el 10 de diciembre de 2021.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué efectos tendrá el 3er retiro en mi pensión?',
            respuesta: '<p>Seg&uacute;n estimaciones, este tercer retiro dejar&aacute; a 5 millones de personas sin saldo en sus cuentas, y las m&aacute;s afectadas ser&iacute;an las mujeres por su renta promedio.<br /><br />Ten presente que este retiro podr&iacute;a provocar una disminuci&oacute;n significativa en el monto de tu futura pensi&oacute;n.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si la cédula de identidad está vencida, ¿Se podrá solicitar igualmente el retiro?',
            respuesta: '<p>S&iacute;, podr&aacute;s solicitar tu retiro con tu <strong>Clave de Seguridad</strong>, aunque tu c&eacute;dula de identidad est&eacute; bloqueada o vencida.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si aún no se han efectuado los pagos anteriores?',
            respuesta: '<p>Como son procesos diferentes, se puede tramitar el tercer retiro del 10% pese a no haber recibido la totalidad del pago de la 1era o 2da solicitud.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Y qué pasa con el bono por parte del Estado de $200.000?',
            respuesta: '<p>Esta ley como tal no considera el pago de un bono para quienes no tengan saldo en su cuenta individual. No obstante, te mantendremos informado si es que se aprueba una nueva normativa que establezca la entrega de un bono.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué ocurrirá con un afiliado que tenga una deuda de pensión alimenticia?',
            respuesta: '<p>Los afiliados que soliciten el 10% de sus ahorros y tengan una deuda de pensi&oacute;n de alimentos, deber&aacute;n informarlo en su solicitud. Por otro lado, el demandante de pensi&oacute;n puede solicitar el 3er retiro del 10% en el caso de que existan varias causas y el monto de retiro sea insuficiente para el pago de cada deuda. En este caso, el Tribunal se encargar&aacute; de liquidar el monto final. Para ello, ser&aacute; el mismo Tribunal quien otorga la autorizaci&oacute;n de la subrogaci&oacute;n.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasa si tengo pendiente una retención anterior por deuda de pensión de alimentos?',
            respuesta: '<p>Las medidas cautelares por deuda de pensi&oacute;n de alimentos son independientes entre s&iacute;, aunque haya alguna vigente en el proceso de retiro.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Tendré que reintegrar el monto que retiré?',
            respuesta: '<p><strong>Los afiliados que soliciten su 3er retiro podr&aacute;n voluntariamente reintegrar ese monto mediante el aumento del 1% de su cotizaci&oacute;n obligatoria mensual</strong>, que subir&aacute; desde el 10% al 11% respecto a su ingreso imponible mensual por un periodo m&iacute;nimo de un a&ntilde;o, salvo que qued&eacute; sin trabajo.<br /><br />Este reintegro es <strong>voluntario y deber&aacute; ser solicitado a la AFP</strong>. En este sentido, el afiliado tendr&aacute; que firmar un formulado llamado &ldquo;Aumento de la cotizaci&oacute;n obligatoria al 11%&rdquo;.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Los pensionados que retiren la totalidad de sus fondos quedarán sin pensión?',
            respuesta: '<p>Quienes reciban una pensi&oacute;n por Retiro Programado y retiren la totalidad de sus ahorros, eventualmente quedar&aacute;n sin saldo para financiar su pensi&oacute;n y <strong>podr&aacute;n postular a la Pensi&oacute;n B&aacute;sica Solidaria.</strong><br /><br />Revisa los requisitos aqu&iacute;: <a href=\"https://planvital.cl/pensionado/beneficios/pension-solidaria\">https://planvital.cl/pensionado/beneficios/pension-solidaria</a></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si estoy en el extranjero, ¿Qué medios de pago puedo elegir para recibir mi 3er retiro?',
            respuesta: '<p>Si est&aacute;s en el extranjero, tienes dos opciones de pago para recibir tu dinero de forma r&aacute;pida y segura: 1) Elige dep&oacute;sito a una cuenta bancaria personal en Chile o 2) Dep&oacute;sito a una cuenta bancaria personal en el extranjero.<br /><br />Para realizar un dep&oacute;sito en tu cuenta bancaria personal en el extranjero, al momento de ingresar tu solicitud de retiro, te pediremos el c&oacute;digo de tu cuenta Swift/BIC, ABA o IBAN, dependiendo de d&oacute;nde te encuentres.<br /><br />Te recomendamos contactar a tu ejecutivo bancario para conocer el c&oacute;digo que tu banco utiliza. Te compartimos ac&aacute; los c&oacute;digos que aplican para las cuentas bancarias en el exterior, de manera que los tengas en consideraci&oacute;n:</p>\n<p><br /><br /></p>\n<table>\n<thead>\n<tr>\n<th>Tipo de c&oacute;digo</th>\n<th>D&iacute;gitos</th>\n<th>Ejemplo</th>\n<th>Alcance</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Swift/ BIC</td>\n<td>8-11</td>\n<td>BBBBESMM000</td>\n<td>Internacional</td>\n</tr>\n<tr>\n<td>ABA (*Routing Number)</td>\n<td>9</td>\n<td>123456789</td>\n<td>Estados Unidos</td>\n</tr>\n<tr>\n<td>IBAN</td>\n<td>22-26</td>\n<td>DE8937040440532013000</td>\n<td>Europa</td>\n</tr>\n</tbody>\n</table>'
          }
        }
      ]
    },
    {
      codigo: 201,
      faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Puedo hacer la solicitud desde hoy?',
            respuesta: '<p>Ya puedes ingresar tu solicitud desde el viernes 14 de mayo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes podrán recibir el bono de hasta $200.000?',
            respuesta: '<p>Podr&aacute;n optar por &uacute;nica vez a un bono fiscal de $200.000, los afiliados o pensionados por vejez, invalidez o sobrevivencia a una AFP que hayan quedado sin saldo en su cuenta previsional obligatoria despu&eacute;s de haber realizado alguno de los retiros del 10%, entre el 30 de julio de 2020 y el 31 de marzo de 2021.</p>\n<p>Tambi&eacute;n podr&aacute;n acceder a este bono los afiliados a una AFP al 1 de enero de 2021 que tengan un saldo menor a $200.000 al 31 de marzo de 2021, puesto que recibir&aacute;n una cantidad igual a la diferencia entre $200.000 y el saldo a esa fecha.</p>\n<p>Te dejamos dos ejemplos:</p>\n<ul>\n<li>Si al 31 de marzo de 2021, tu saldo era de $150.000, el bono de cargo fiscal que ser&aacute; abonado a tu cuenta previsional obligatoria de la AFP ser&aacute; de $50.000</li>\n<li>Si al 31 de marzo de 2021, no ten&iacute;as saldo en tu cuenta previsional obligatoria de la AFP, el bono de cargo fiscal ser&aacute; de $200.000</li>\n</ul>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo sabré si soy beneficiario/a?',
            respuesta: '<p>Te enviaremos un e-mail y SMS confirmando si eres beneficiario/a y el monto que te corresponde. A partir del viernes 14 de mayo de 2021, podr&aacute;s ingresar tu solicitud en <a href=\"https://retirounico.planvital.cl/bono-cargo-fiscal\" target=\"_blank\" rel=\"noopener\">retirounico.planvital.cl/bono-cargo-fiscal</a>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo y cuándo será depositado el bono?',
            respuesta: '<p>El bono ser&aacute; depositado por la Tesorer&iacute;a General de la Rep&uacute;blica en las cuentas individuales de los afiliados/as a m&aacute;s tardar el 7 de junio de 2021.</p>\n<p>Los afiliados podr&aacute;n retirar este bono, si as&iacute; lo desean, ingresando una solicitud en <a href=\"https://retirounico.planvital.cl/bono-cargo-fiscal\" target=\"_blank\" rel=\"noopener\">retirounico.planvital.cl/bono-cargo-fiscal</a>. En un plazo de 15 d&iacute;as h&aacute;biles despu&eacute;s de ingresada la solicitud de retiro del bono de Cargo Fiscal, el bono ser&aacute; depositado al medio de pago seleccionado por el beneficiario.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se cobrará algún tipo de comisión por la administración del bono?',
            respuesta: '<p>En ning&uacute;n caso. Este bono est&aacute; libre de comisiones.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si tengo ahorros en mis cuentas voluntarias (APV o Cuenta 2) y no tengo saldo en la cuenta de cotización obligatoria, ¿Recibiré el Bono de Cargo Fiscal?',
            respuesta: '<p>Se considera el saldo de la cuenta de ahorro previsional obligatoria y de afiliado voluntario para determinar si una persona es beneficiaria del bono de cargo fiscal, no as&iacute; los ahorros de APV o Cuenta 2.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si soy afiliado y a la vez beneficiario de una pensión, ¿Recibiré dos veces el bono?',
            respuesta: '<p>Si cumples con los requisitos para acceder al bono, lo recibir&aacute;s solo una vez.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Hasta qué fecha puedo retirar el Bono de Cargo Fiscal?',
            respuesta: '<p>Tienes un a&ntilde;o para hacer la solicitud, a partir del 8 de mayo de 2021.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: 'Si tengo una deuda por pensión alimenticia, ¿El monto del bono podría ser retenido?',
            respuesta: '<p>S&iacute;, el bono podr&iacute;a ser retenido por una deuda de pensi&oacute;n de alimentos.</p>\n<p>Si esta deuda no corresponde, podr&aacute;s realizar la solicitud por subrogaci&oacute;n.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿En qué casos mi solicitud de bono de Cargo Fiscal puede ser rechazada?',
            respuesta: '<p>Si algunos de los datos ingresados en tu solicitud de Bono de Cargo Fiscal est&aacute;n incorrectos, tu solicitud ser&aacute; rechazada. Ten en cuenta los siguientes consejos para evitar estos errores:</p>\n<ul>\n<li>Ten a mano siempre tu c&eacute;dula de identidad con el RUT y n&uacute;mero de serie al momento de ingresar tu solicitud.</li>\n<li>No ingreses una cuenta bipersonal, es decir, con m&aacute;s de un titular ni tampoco ingreses cuentas digitales que hayan sido abiertas de manera presencial.</li>\n<li>Si no eres titular de una cuenta bancaria, recuerda que puedes solicitar el pago de una Cuenta de Ahorro Voluntario (Cuenta 2) sin costo para ti.</li>\n</ul>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué documentos necesita un beneficiario para solicitar el bono desde el extranjero?',
            respuesta: '<p>Para solicitar el bono desde el extranjero ten en cuenta estos tres documentos:</p>\n<ol>\n<li>Certificado de identificaci&oacute;n</li>\n<li>Certificado de residencia</li>\n<li>Certificado de cuenta corriente</li>\n</ol>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son los medios de pago para el depósito del bono de Cargo Fiscal desde el extranjero?',
            respuesta: '<p>Ac&aacute; tienes dos alternativas. La primera es solicitar el dep&oacute;sito a una cuenta bancaria personal en Chile y la segunda es solicitar dep&oacute;sito a una cuenta bancaria personal en el extranjero</p>\n<p>Si eliges la segunda opci&oacute;n, considera el c&oacute;digo de tu cuenta extranjera que puede ser Swift o BIC, ABA o IBAN, dependiendo el pa&iacute;s en donde est&eacute;s.</p>\n<table>\n<thead>\n<tr>\n<th>Tipo de C&oacute;digo</th>\n<th>D&iacute;gitos</th>\n<th>Ejemplo</th>\n<th>Alcance</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>SWIFT / BIC</td>\n<td>8 - 11</td>\n<td>BBBBESMM000</td>\n<td>Internacional</td>\n</tr>\n<tr>\n<td>ABA (<em>\"Routing Number\"</em> )</td>\n<td>9</td>\n<td>123456789</td>\n<td>Estados Unidos</td>\n</tr>\n<tr>\n<td>IBAN</td>\n<td>22 - 26</td>\n<td>DE8937040440532013000</td>\n<td>Europa</td>\n</tr>\n</tbody>\n</table>'
          }
        }
      ]
    },
    {
      codigo: 4,
      faqs: []
    },
    {
      codigo: 301,
      faqs: []
    }
  ],
  public: true
};
export const LANDING_FAQS_INFO_RESPONSE = {
  data: [
    {
      codigo: 1,
      landing_faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con mi solicitud de retiro si fallezco antes del pago?',
            respuesta: '<p>Si el afiliado fallece despu&eacute;s de aceptada su solicitud y antes del pago del monto total del retiro, el saldo pendiente de pago deber&aacute; ser pagado como herencia, a&uacute;n si existieren beneficiarios de pensi&oacute;n de sobrevivencia.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Hasta cuándo se puede solicitar el retiro del 10%?',
            respuesta: '<p>El plazo para hacer la solicitud es hasta el <strong>31 de julio de 2021.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿A través de qué medios puedo solicitar el retiro de los fondos?',
            respuesta: '<p>Hasta el 2 de agosto el proceso <strong>ser&aacute; digital</strong> y los afiliados deber&aacute;n solicitar su retiro a trav&eacute;s de la <strong>p&aacute;gina web de la AFP</strong>, solo con su RUT y el n&uacute;mero de serie del carnet de identidad. A partir de esa fecha, las sucursales de AFP atender&aacute;n a los afiliados que requieran solicitar su retiro de acuerdo con un orden establecido por cada Administradora, con el objetivo de cumplir con las medidas y recomendaciones sanitarias en las sucursales. Adem&aacute;s, los afiliados pueden solicitar el retiro a trav&eacute;s del call center de cada AFP.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué monto se puede retirar?',
            respuesta: '<p>La Ley permite el retiro de <strong>hasta 10% de los fondos ahorrados</strong>. Se establece que <strong>el m&iacute;nimo a retirar ser&aacute; 35 UF</strong> (aproximadamente $1.000.000) y <strong>el m&aacute;ximo 150 UF</strong> ($4.300.000). Si un afiliado tiene menos de 35 UF, podr&aacute; retirar <strong>el total del fondo ahorrado en su cuenta</strong>.</p>\n<p>En la solicitud de retiro, el afiliado deber&aacute; indicar si desea retirar el 100% de lo permitido o un monto menor.</p>\n<p>Valores aproximados y calculados con el valor de la UF vigente al 27 de julio 2020, de $28.671,14</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes pueden solicitar el retiro de su 10%?',
            respuesta: '<p><strong>Todas las personas que tengan saldo en su cuenta</strong> de capitalizaci&oacute;n individual pueden acceder al retiro. Esto incluye a los <strong>pensionados por vejez, invalidez o sobrevivencia</strong>.</p>\n<p>Adem&aacute;s, este es un <strong>retiro universal</strong>, es decir, que todos los afiliados en las AFP, sin exclusi&oacute;n, pueden optar a esta alternativa. Esto considera a los <strong>trabajadores</strong>, tanto del <strong>sector p&uacute;blico</strong> como del <strong>privado</strong> y tanto a los <strong>chilenos</strong> como <strong>extranjeros.</strong></p>'
          }
        }
      ]
    },
    {
      codigo: 2,
      landing_faqs: [
        {
          ret_faqs_id: {
            pregunta: 'Si ya realicé mi primer retiro, ¿Puedo solicitar el segundo?',
            respuesta: '<p>S&iacute;, mientras tengas saldo en tu cuenta obligatoria o voluntaria.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuáles son los montos de retiro?',
            respuesta: '<p>Al igual que el primer retiro, el <strong>monto m&iacute;nimo ser&aacute; de 35 UF</strong> (cerca de $1 mill&oacute;n) y <strong>m&aacute;ximo 150 UF</strong> (cerca de $4.3 millones).<br />Si el saldo es <strong>inferior a 35 UF</strong>, se podr&aacute; retirar <strong>el total de los ahorros.</strong></p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo se hará el pago?',
            respuesta: '<p>1. La <strong>primera cuota del 50%</strong> se pagar&aacute; en un plazo m&aacute;ximo de <strong>10 d&iacute;as h&aacute;biles </strong>desde que hiciste la solicitud. 2. La <strong>segunda cuota del 50%</strong> restante se pagar&aacute; en un plazo m&aacute;ximo de <strong>10 d&iacute;as h&aacute;biles </strong> despu&eacute;s del primer pago.<br />Para montos <strong>iguales o inferiores a 35 UF</strong>, el pag&oacute; se har&aacute; en <strong>una sola cuota</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo solicito mi 1er y 2do retiro?',
            respuesta: '<p>Para solicitar tu <strong>primer retiro</strong> de fondos, haz <a href=\"${MAIN_ROUTES.FIRST_WITHDRAWAL}\">clic aqu&iacute;</a>.<br />Para solicitar tu <strong>segundo retiro</strong> de fondos, haz <a href=\"${MAIN_ROUTES.SECOND_WITHDRAWAL}\">clic aqu&iacute;</a>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Qué pasará con los deudores de pensión de alimentos en este segundo retiro?',
            respuesta: '<p>Se <strong>aprob&oacute; el retiro forzoso</strong> para quienes tengan deudas por pensi&oacute;n de alimentos.</p>'
          }
        }
      ]
    },
    {
      codigo: 3,
      landing_faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes pueden acceder al 3er retiro?',
            respuesta: '<p>Tienen derecho a solicitar el 3er retiro del 10% los <strong>afiliados o pensionados por Retiro Programado o Renta Temporal</strong> que est&eacute;n en Chile o en el extranjero (incluido quienes hayan obtenido el beneficio de pensi&oacute;n Anticipada por Enfermedad) que tengan saldo en sus cuentas individuales.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuánto dinero podré retirar?',
            respuesta: '<p>La Ley permite el retiro de <strong>hasta 10% de los fondos ahorrados</strong>. Se establece que <strong>el m&iacute;nimo a retirar ser&aacute; 35 UF</strong> (aproximadamente $1.000.000) y <strong>el m&aacute;ximo 150 UF</strong> ($4.300.000). Si un afiliado tiene menos de 35 UF, podr&aacute; retirar <strong>el total del fondo ahorrado en su cuenta</strong>.</p>\n<p>En la solicitud de retiro, el afiliado deber&aacute; indicar si desea retirar el 100% de lo permitido o un monto menor.</p>\n<p>Valores aproximados y calculados con el valor de la UF vigente al 3 de mayo de 2021, de $29.505,91</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuál es el plazo para solicitar el 3er retiro?',
            respuesta: '<p>El plazo para realizar la solicitud de retiro es de 365 d&iacute;as desde el <strong>lunes 3 de mayo de 2021</strong>, desde las 9:00 horas. Es decir, si un afiliado no necesita hacer el retiro de forma inmediata, tendr&aacute; plazo de un a&ntilde;o para hacerlo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cuándo se hará el pago?',
            respuesta: '<p>Te informaremos si tu solicitud fue aprobada o rechazada en un plazo de cuatro d&iacute;as h&aacute;biles contados desde el ingreso de la solicitud. En caso de ser aprobada, tu pago estar&aacute; disponible en <strong>15 d&iacute;as h&aacute;biles</strong>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Por qué medios se podrá hacer la solicitud?',
            respuesta: '<p>Podr&aacute;s hacer tu solicitud a trav&eacute;s de nuestros canales: <strong>sitio web <a href=\"https://planvital.cl\">planvital.cl</a>, Contact Center 800 072 072 y en nuestras sucursales</strong>. No obstante, y para resguardar tu salud, privilegia nuestros canales digitales.</p>'
          }
        }
      ]
    },
    {
      codigo: 201,
      landing_faqs: [
        {
          ret_faqs_id: {
            pregunta: '¿Puedo hacer la solicitud desde hoy?',
            respuesta: '<p>Ya puedes ingresar tu solicitud desde el viernes 14 de mayo.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Quiénes podrán recibir el bono de hasta $200.000?',
            respuesta: '<p>Podr&aacute;n optar por &uacute;nica vez a un bono fiscal de $200.000, los afiliados o pensionados por vejez, invalidez o sobrevivencia a una AFP que hayan quedado sin saldo en su cuenta previsional obligatoria despu&eacute;s de haber realizado alguno de los retiros del 10%, entre el 30 de julio de 2020 y el 31 de marzo de 2021.</p>\n<p>Tambi&eacute;n podr&aacute;n acceder a este bono los afiliados a una AFP al 1 de enero de 2021 que tengan un saldo menor a $200.000 al 31 de marzo de 2021, puesto que recibir&aacute;n una cantidad igual a la diferencia entre $200.000 y el saldo a esa fecha.</p>\n<p>Te dejamos dos ejemplos:</p>\n<ul>\n<li>Si al 31 de marzo de 2021, tu saldo era de $150.000, el bono de cargo fiscal que ser&aacute; abonado a tu cuenta previsional obligatoria de la AFP ser&aacute; de $50.000</li>\n<li>Si al 31 de marzo de 2021, no ten&iacute;as saldo en tu cuenta previsional obligatoria de la AFP, el bono de cargo fiscal ser&aacute; de $200.000</li>\n</ul>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo sabré si soy beneficiario/a?',
            respuesta: '<p>Te enviaremos un e-mail y SMS confirmando si eres beneficiario/a y el monto que te corresponde. A partir del viernes 14 de mayo de 2021, podr&aacute;s ingresar tu solicitud en <a href=\"https://retirounico.planvital.cl/bono-cargo-fiscal\" target=\"_blank\" rel=\"noopener\">retirounico.planvital.cl/bono-cargo-fiscal</a>.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Cómo y cuándo será depositado el bono?',
            respuesta: '<p>El bono ser&aacute; depositado por la Tesorer&iacute;a General de la Rep&uacute;blica en las cuentas individuales de los afiliados/as a m&aacute;s tardar el 7 de junio de 2021.</p>\n<p>Los afiliados podr&aacute;n retirar este bono, si as&iacute; lo desean, ingresando una solicitud en <a href=\"https://retirounico.planvital.cl/bono-cargo-fiscal\" target=\"_blank\" rel=\"noopener\">retirounico.planvital.cl/bono-cargo-fiscal</a>. En un plazo de 15 d&iacute;as h&aacute;biles despu&eacute;s de ingresada la solicitud de retiro del bono de Cargo Fiscal, el bono ser&aacute; depositado al medio de pago seleccionado por el beneficiario.</p>'
          }
        },
        {
          ret_faqs_id: {
            pregunta: '¿Se cobrará algún tipo de comisión por la administración del bono?',
            respuesta: '<p>En ning&uacute;n caso. Este bono est&aacute; libre de comisiones.</p>'
          }
        }
      ]
    },
    {
      codigo: 4,
      landing_faqs: []
    },
    {
      codigo: 301,
      landing_faqs: []
    }
  ],
  public: true,
};
export const MORE_INFO_BY_WITHDRAWAL_RESPONSE = {
  data: [
    {
      codigo: 1,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Plazos',
            titulo: '¿Cuál es el plazo para realizar el Primer retiro?',
            cuerpo: '<p>El plazo para hacer la solicitud es hasta el <strong>31 de julio de 2021</strong>.</p>',
            imagen: {
              data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                asset_url: '/sitio-publico/assets/mxv8sym7cyokoowg',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Beneficiarios',
            titulo: '¿Quiénes pueden hacer la solicitud?',
            cuerpo: '<p>Podr&aacute;n hacer la solicitud todos los afiliados, pensionados o beneficiarios de una AFP con saldo en sus cuentas.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Montos',
            titulo: '¿Cuáles son los montos a retirar?',
            cuerpo: '<p>Los montos de retiro son: 150 UF ($4,3 millones apr&oacute;x) y 35 UF (cerca de $1 mill&oacute;n).<br />Cuando el saldo sea inferior a 35 UF (cerca de $1 mill&oacute;n), se podr&aacute; retirar la totalidad de los ahorros.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                asset_url: '/sitio-publico/assets/qthxa63r2mss4owc',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley Nº 21248',
            titulo: 'Ley Nº 21248',
            cuerpo: '<p>Para mayor informaci&oacute;n, dejamos a tu disposici&oacute;n la descarga del documento de la Ley N&ordm; 21248.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: 'Descargar documento',
            boton_link: 'https://storage.googleapis.com/pv-site-public-files/retiro-pdfs/LEY_21248.pdf'
          }
        }
      ]
    },
    {
      codigo: 2,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Beneficiarios',
            titulo: '¿Quiénes pueden hacer la solicitud?',
            cuerpo: '<p>Los afiliados a una AFP que est&eacute;n en Chile o el extranjero con saldos en sus cuentas.<br />Asimismo, los beneficiarios por pensi&oacute;n de sobrevivencia y los pensionados por renta temporal o retiro programado (vejez, vejez anticipada o invalidez).</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Montos',
            titulo: '¿Cuáles son los montos a retirar?',
            cuerpo: '<p>Los montos de retiro son: 150 UF ($4,3 millones apr&oacute;x) y 35 UF (cerca de $1 mill&oacute;n).<br />Cuando el saldo sea inferior a 35 UF (cerca de $1 mill&oacute;n), se podr&aacute; retirar la totalidad de los ahorros.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                asset_url: '/sitio-publico/assets/qthxa63r2mss4owc',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Plazos',
            titulo: '¿Cuál es el plazo para realizar el Segundo retiro?',
            cuerpo: '<p>A partir del jueves 10 de diciembre, tienes hasta 365 d&iacute;as para hacer tu solicitud de retiro.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                asset_url: '/sitio-publico/assets/mxv8sym7cyokoowg',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley Nº 21295',
            titulo: 'Ley Nº 21295',
            cuerpo: '<p>Para mayor informaci&oacute;n, dejamos a tu disposici&oacute;n la descarga del documento de la Ley N&ordm; 21295.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: 'Descargar documento',
            boton_link: 'https://storage.googleapis.com/pv-site-public-files/retiro-pdfs/LEY_21295.pdf'
          }
        }
      ]
    },
    {
      codigo: 3,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Beneficiarios',
            titulo: '¿Quiénes pueden hacer la solicitud?',
            cuerpo: '<p>Este proyecto permite a los afiliados a una AFP que est&eacute;n en Chile o en el extranjero, retirar hasta el 10% de sus ahorros previsionales.<br /><br />Las &uacute;nicas personas que no tienen la posibilidad de solicitar sus fondos son aquellas que se encuentren dentro del art&iacute;culo 38 bis de la Constituci&oacute;n (Presidente de la Rep&uacute;blica, senadores, diputados, ministros, subsecretarios, gobernadores regionales, delegados presidenciales regionales y provinciales, salvo quienes hayan sido contratados a honorarios y que est&eacute;n a cargo de asesorar a las autoridades citadas).</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Montos',
            titulo: '¿Cuáles son los montos a retirar?',
            cuerpo: '<p>Los montos de retiro son: 150 UF ($4,3 millones apr&oacute;x) y 35 UF (cerca de $1 mill&oacute;n).<br />Cuando el saldo sea inferior a 35 UF (cerca de $1 mill&oacute;n), se podr&aacute; retirar la totalidad de los ahorros.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                asset_url: '/sitio-publico/assets/qthxa63r2mss4owc',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Plazos',
            titulo: '¿Cuál es el plazo para realizar el Tercer retiro?',
            cuerpo: '<p>A partir del lunes 3 de mayo, desde las 9:00 hrs. Tienes hasta 365 d&iacute;as para hacer tu solicitud de retiro.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                asset_url: '/sitio-publico/assets/mxv8sym7cyokoowg',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley Nº 21330',
            titulo: 'Ley Nº 21330',
            cuerpo: '<p>Para mayor informaci&oacute;n, dejamos a tu disposici&oacute;n la descarga del documento de la Ley N&ordm; 21330.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: 'Descargar documento',
            boton_link: 'https://storage.googleapis.com/pv-site-public-files/retiro-pdfs/LEY_21330.pdf'
          }
        }
      ]
    },
    {
      codigo: 201,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Beneficiarios',
            titulo: '¿Quiénes son los beneficiarios de este Bono de Cargo Fiscal?',
            cuerpo: '<ul>\n<li>Afiliados/as o pensionados/as a una AFP que hayan quedado sin saldo en su cuenta previsional obligatoria despu&eacute;s de realizar alguno de los retiros de 10% en el periodo entre la entrada en vigencia de la ley del primer retiro, 30 de julio de 2020 hasta el 31 de marzo de 2021</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li>Afiliados que al 31 de marzo de 2021 tengan un saldo menor a $200.000 en sus cuentas individuales.</li>\n</ul>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Montos',
            titulo: '¿Cuáles son los montos a retirar?',
            cuerpo: '<p>Tanto los beneficiarios como los montos del bono ser&aacute;n determinados por la Tesorer&iacute;a General de la Rep&uacute;blica.</p>\n<ul>\n<li><strong>Si quedaste con saldo cero</strong> despu&eacute;s de haber realizado retiros de tu cuenta de ahorro previsional obligatorio entre el 30 de julio de 2021 y el 31 de marzo de 2021, <strong>eres candidato para recibir $200.000.</strong></li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li>Si no perteneces al grupo anterior, y al 31 de marzo de 2021, <strong>tu saldo en tu cuenta de ahorro previsional obligatorio era menor a $200.000</strong>, te corresponde un <strong>bono variable equivalente al remanente entre tu saldo a esa fecha y $200.000.</strong></li>\n</ul>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
                asset_url: '/sitio-publico/assets/qthxa63r2mss4owc',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Plazos',
            titulo: '¿Cuál es el plazo para realizar la solicitud del bono fiscal?',
            cuerpo: '<p>Las solicitudes para los beneficiarios del bono de cargo fiscal estar&aacute;n disponibles <strong>a partir del d&iacute;a viernes 14 de mayo.</strong><br />Este jueves 13 informaremos v&iacute;a correo electr&oacute;nico a nuestros afiliados/as y pensionados/as que hayan sido seleccionadas por la Tesorer&iacute;a General de la Rep&uacute;blica como beneficiarias del bono.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/d0633df2-6fe1-43a0-af22-0380aee7ffe0.svg',
                asset_url: '/sitio-publico/assets/mxv8sym7cyokoowg',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley Nº 21339',
            titulo: 'Ley Nº 21339',
            cuerpo: '<p>Para mayor informaci&oacute;n, dejamos a tu disposici&oacute;n la descarga del documento de la Ley N&ordm; 21339.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: 'Descargar documento',
            boton_link: 'https://storage.googleapis.com/pv-site-public-files/retiro-pdfs/LEY_21339.pdf'
          }
        }
      ]
    },
    {
      codigo: 4,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Dónde',
            titulo: '¿Desde dónde puedo hacer mi solicitud?',
            cuerpo: '<p>Haz tu solicitud del 10% tanto en Chile como el extranjero.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Información',
            titulo: '¡Importante!',
            cuerpo: '<p>Puedes solicitar tu retiro del 10% con tu c&eacute;dula vencida o bloqueada.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        }
      ]
    },
    {
      codigo: 301,
      mas_informaciones: [
        {
          ret_mas_informacion_id: {
            tab: 'Dónde',
            titulo: '¿Desde dónde puedo hacer mi solicitud?',
            cuerpo: '<p>Haz tu solicitud del 10% tanto en Chile como el extranjero.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
                asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Información',
            titulo: '¡Importante!',
            cuerpo: '<p>Puedes solicitar tu retiro del 10% con tu c&eacute;dula vencida o bloqueada.</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley 20.850',
            titulo: 'Acerca de la ley 20.850',
            cuerpo: '<p>Completar aqu&iacute; con informaci&oacute;n sobre la ley 20.850</p>',
            imagen: {
               data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        },
        {
          ret_mas_informacion_id: {
            tab: 'Ley 19.779',
            titulo: 'Acerca de la ley 19.779',
            cuerpo: '<p>Completar aqu&iacute; con informaci&oacute;n sobre la ley 19.779</p>',
            imagen: {
              data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
                asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
                thumbnails: null,
                embed: null,
                alt: ''
              }
            },
            boton_texto: null,
            boton_link: null
          }
        }
      ]
    }
  ]
};
export const HOME_MORE_INFO_RESPONSE: HomeMoreInformation = {
  mas_informaciones: [{
      ret_mas_informacion_id: {
        tab: 'Dónde',
        titulo: '¿Desde dónde puedo hacer mi solicitud?',
        cuerpo: '<p>Haz tu solicitud del 10% tanto en Chile como el extranjero.</p>',
        imagen: {
          data: {
            full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
            url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f3b51103-a94e-4c0b-bbf7-cb9a037663ce.svg',
            asset_url: '/sitio-publico/assets/qy0gmlw3aio00oc4',
            thumbnails: null,
            embed: null
          }
        },
        boton_texto: null,
        boton_link: null
      }
    },
    {
      ret_mas_informacion_id: {
        tab: 'Información',
        titulo: '¡Importante!',
        cuerpo: '<p>Puedes solicitar tu retiro del 10% con tu c&eacute;dula vencida o bloqueada.</p>',
        imagen: {
          data: {
            full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
            url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b131425d-57d1-46d8-bcce-fd60f0fa92e0.svg',
            asset_url: '/sitio-publico/assets/8ga6khisw38csgg4',
            thumbnails: null,
            embed: null,
            alt: ''
          }
        },
        boton_texto: null,
        boton_link: null
      }
    },
    {
      ret_mas_informacion_id: {
        tab: 'Monto',
        titulo: '¿Cuánto puedo retirar?',
        cuerpo: '<p>Si el monto de tus ahorros es igual o inferior a 35 UF (cerca de $1.000.000), podr&aacute;s retirar la totalidad. El monto m&aacute;ximo de retiro es hasta 150 UF (cerca de $4.300.000).</p>',
        imagen: {
          data: {
            full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
            url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b2fd0dc9-d318-4ce8-9d3b-3ffd1795bc9a.svg',
            asset_url: '/sitio-publico/assets/qthxa63r2mss4owc',
            thumbnails: null,
            embed: null
          }
        },
        boton_texto: null,
        boton_link: null
      }
    }]
};
export const WITHDRAWAL_BANNER_INFO_RESPONSE = {
data: [
  {
    banner: {
      data: {
          full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b507666c-05f5-4dcc-b198-70a6e3d75b23.jpg',
          url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/b507666c-05f5-4dcc-b198-70a6e3d75b23.jpg',
          asset_url: '/sitio-publico/assets/5xdadaz7mygwgwsc',
          thumbnails: [
              {
                  key: 'directus-small-crop',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-small-crop',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-small-crop',
                  dimension: '64x64',
                  width: 64,
                  height: 64
              },
              {
                  key: 'directus-small-contain',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-small-contain',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-small-contain',
                  dimension: '64x64',
                  width: 64,
                  height: 64
              },
              {
                  key: 'directus-medium-crop',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-medium-crop',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-medium-crop',
                  dimension: '300x300',
                  width: 300,
                  height: 300
              },
              {
                  key: 'directus-medium-contain',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-medium-contain',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-medium-contain',
                  dimension: '300x300',
                  width: 300,
                  height: 300
              },
              {
                  key: 'directus-large-crop',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-large-crop',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-large-crop',
                  dimension: '800x600',
                  width: 800,
                  height: 600
              },
              {
                  key: 'directus-large-contain',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-large-contain',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=directus-large-contain',
                  dimension: '800x600',
                  width: 800,
                  height: 600
              },
              {
                  key: 'thumbnail',
                  url: 'http://35.186.243.77/sitio-publico/assets/5xdadaz7mygwgwsc?key=thumbnail',
                  relative_url: '/sitio-publico/assets/5xdadaz7mygwgwsc?key=thumbnail',
                  dimension: '200x200',
                  width: 200,
                  height: 200
              }
          ],
          embed: null
      }
  },
    titulo_landing: '1er Retiro 10% de los Fondos de Pensiones',
    titulo_faqs: 'Preguntas Frecuentes del primer retiro',
    codigo: 1
  },
  {
      banner: {
          data: {
              full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f5f0ef09-1571-47ea-ae8a-60797647d6cd.jpg',
              url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f5f0ef09-1571-47ea-ae8a-60797647d6cd.jpg',
              asset_url: '/sitio-publico/assets/fhyiz22phqo84k4c',
              thumbnails: [
                  {
                      key: 'directus-small-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-small-crop',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-small-crop',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-small-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-small-contain',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-small-contain',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-medium-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-medium-crop',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-medium-crop',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-medium-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-medium-contain',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-medium-contain',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-large-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-large-crop',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-large-crop',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'directus-large-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-large-contain',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=directus-large-contain',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'thumbnail',
                      url: 'http://35.186.243.77/sitio-publico/assets/fhyiz22phqo84k4c?key=thumbnail',
                      relative_url: '/sitio-publico/assets/fhyiz22phqo84k4c?key=thumbnail',
                      dimension: '200x200',
                      width: 200,
                      height: 200
                  }
              ],
              embed: null
          }
      },
      titulo_landing: '2do Retiro 10% de los Fondos de Pensiones',
      titulo_faqs: 'Preguntas Frecuentes del segundo retiro',
      codigo: 2
  },
  {
      banner: {
          data: {
              full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/a8d5c317-2c41-4ccc-82a4-c7dd7969c994.jpg',
              url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/a8d5c317-2c41-4ccc-82a4-c7dd7969c994.jpg',
              asset_url: '/sitio-publico/assets/goa63ydpsp44oos8',
              thumbnails: [
                  {
                      key: 'directus-small-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-small-crop',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-small-crop',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-small-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-small-contain',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-small-contain',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-medium-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-medium-crop',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-medium-crop',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-medium-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-medium-contain',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-medium-contain',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-large-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-large-crop',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-large-crop',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'directus-large-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=directus-large-contain',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=directus-large-contain',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'thumbnail',
                      url: 'http://35.186.243.77/sitio-publico/assets/goa63ydpsp44oos8?key=thumbnail',
                      relative_url: '/sitio-publico/assets/goa63ydpsp44oos8?key=thumbnail',
                      dimension: '200x200',
                      width: 200,
                      height: 200
                  }
              ],
              embed: null
          }
      },
      titulo_landing: '3er Retiro 10% de los Fondos de Pensiones',
      titulo_faqs: 'Preguntas Frecuentes del tercer retiro',
      codigo: 3
  },
  {
      banner: {
          data: {
              full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/5d06c044-c049-410a-b9ac-dd8dd5ce951a.jpg',
              url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/5d06c044-c049-410a-b9ac-dd8dd5ce951a.jpg',
              asset_url: '/sitio-publico/assets/3xes8ygxyse8cgo4',
              thumbnails: [
                  {
                      key: 'directus-small-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-small-crop',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-small-crop',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-small-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-small-contain',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-small-contain',
                      dimension: '64x64',
                      width: 64,
                      height: 64
                  },
                  {
                      key: 'directus-medium-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-medium-crop',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-medium-crop',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-medium-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-medium-contain',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-medium-contain',
                      dimension: '300x300',
                      width: 300,
                      height: 300
                  },
                  {
                      key: 'directus-large-crop',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-large-crop',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-large-crop',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'directus-large-contain',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-large-contain',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=directus-large-contain',
                      dimension: '800x600',
                      width: 800,
                      height: 600
                  },
                  {
                      key: 'thumbnail',
                      url: 'http://35.186.243.77/sitio-publico/assets/3xes8ygxyse8cgo4?key=thumbnail',
                      relative_url: '/sitio-publico/assets/3xes8ygxyse8cgo4?key=thumbnail',
                      dimension: '200x200',
                      width: 200,
                      height: 200
                  }
              ],
              embed: null
          }
      },
      titulo_landing: 'Bono de Cargo Fiscal',
      titulo_faqs: 'Preguntas Frecuentes del bono de cargo fiscal',
      codigo: 201
    }
  ]
};
export const HOME_BANNER_RESPONSE = {
        banner: {
            data: {
                full_url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f7974991-cd9f-4f3e-84bb-ca2724d58763.jpg',
                url: 'https://storage.googleapis.com/pv-directus-dev/sitio-publico/originals/f7974991-cd9f-4f3e-84bb-ca2724d58763.jpg',
                asset_url: '/sitio-publico/assets/3oiud12qqxes8occ',
                thumbnails: [
                    {
                        key: 'directus-small-crop',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-small-crop',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-small-crop',
                        dimension: '64x64',
                        width: 64,
                        height: 64
                    },
                    {
                        key: 'directus-small-contain',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-small-contain',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-small-contain',
                        dimension: '64x64',
                        width: 64,
                        height: 64
                    },
                    {
                        key: 'directus-medium-crop',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-medium-crop',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-medium-crop',
                        dimension: '300x300',
                        width: 300,
                        height: 300
                    },
                    {
                        key: 'directus-medium-contain',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-medium-contain',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-medium-contain',
                        dimension: '300x300',
                        width: 300,
                        height: 300
                    },
                    {
                        key: 'directus-large-crop',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-large-crop',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-large-crop',
                        dimension: '800x600',
                        width: 800,
                        height: 600
                    },
                    {
                        key: 'directus-large-contain',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=directus-large-contain',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=directus-large-contain',
                        dimension: '800x600',
                        width: 800,
                        height: 600
                    },
                    {
                        key: 'thumbnail',
                        url: 'http://35.186.243.77/sitio-publico/assets/3oiud12qqxes8occ?key=thumbnail',
                        relative_url: '/sitio-publico/assets/3oiud12qqxes8occ?key=thumbnail',
                        dimension: '200x200',
                        width: 200,
                        height: 200
                    }
                ],
                embed: null
            }
        },
        titulo_landing: 'Proyecto retiro 10% de los Fondos de Pensiones'

};
export const REQUEST_FORM_INFO_RESPONSE = {
  data: [
    {
      codigo_retiro: 1,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado bajo la modalidad de retiro programado, tu pensión se recalculará considerando el menor saldo de la cuenta individual en el mes en que corresponde tu anualidad. Si efectúas el retiro por la totalidad del saldo de tu cuenta individual de cotizaciones obligatorias, podrías quedar sin pensión, de no tener acceso a beneficios del pilar solidario.'
          }
        }
      ]
    },
    {
      codigo_retiro: 2,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado bajo la modalidad de retiro programado, tu pensión se recalculará considerando el menor saldo de la cuenta individual en el mes en que corresponde tu anualidad. Si efectúas el retiro por la totalidad del saldo de tu cuenta individual de cotizaciones obligatorias, podrías quedar sin pensión, de no tener acceso a beneficios del pilar solidario.'
          }
        }
      ]
    },
    {
      codigo_retiro: 3,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado bajo la modalidad de retiro programado, tu pensión se recalculará considerando el menor saldo de la cuenta individual en el mes en que corresponde tu anualidad. Si efectúas el retiro por la totalidad del saldo de tu cuenta individual de cotizaciones obligatorias, podrías quedar sin pensión, de no tener acceso a beneficios del pilar solidario.'
          }
        }
      ]
    },
    {
      codigo_retiro: 201,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado bajo la modalidad de retiro programado, tu pensión se recalculará considerando el menor saldo de la cuenta individual en el mes en que corresponde tu anualidad. Si efectúas el retiro por la totalidad del saldo de tu cuenta individual de cotizaciones obligatorias, podrías quedar sin pensión, de no tener acceso a beneficios del pilar solidario.'
          }
        }
      ]
    },
    {
      codigo_retiro: 4,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado bajo la modalidad de retiro programado, tu pensión se recalculará considerando el menor saldo de la cuenta individual en el mes en que corresponde tu anualidad. Si efectúas el retiro por la totalidad del saldo de tu cuenta individual de cotizaciones obligatorias, podrías quedar sin pensión, de no tener acceso a beneficios del pilar solidario.'
          }
        }
      ]
    },
    {
      codigo_retiro: 301,
      mensaje_autoridad_afiliado: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que eres una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_medio_de_pago: {
        texto: '<div>\n<div>No est&aacute; autorizado el dep&oacute;sito en cuentas bipersonales (con m&aacute;s de un titular), ni en cuentas digitales con procesos de apertura no presenciales. Evita el rechazo de tu solicitud.</div>\n</div>'
      },
      mensaje_autoridad_beneficiario: {
        texto: '<p>Al <strong>marcar la opci&oacute;n &ldquo;S&iacute;&rdquo;</strong>, est&aacute;s declarando bajo juramento que el beneficiario es una autoridad p&uacute;blica de las se&ntilde;aladas en el art&iacute;culo 38 bis, tales como Presidente de la Rep&uacute;blica, Senadores, Diputados, Ministros de Estado, Gobernadores Regionales, funcionarios de exclusiva confianza del Jefe de Estado que se&ntilde;alan los n&uacute;meros 7 y 10 del art&iacute;culo 32 de la Constituci&oacute;n Pol&iacute;tica del Estado, <strong>con excepci&oacute;n de los trabajadores a honorarios</strong>, en caso contrario <strong>marca la opci&oacute;n &ldquo;No&rdquo;</strong>.</p>'
      },
      alerta_cuenta_2: {
        texto: '<p>Es una cuenta de ahorro voluntario, parecida al APV, donde puedes depositar tu retiro. <br />Recuerda que puedes hacer hasta 24 giros al a&ntilde;o en esta cuenta, sin costo.</p>'
      },
      modal_alertas: [
        {
          ret_textos_formulario_id: {
            texto: 'Si eres afiliado a AFP PlanVital y además recibes una pensión de sobrevivencia en AFP PlanVital, tendrás que ingresar una solicitud de retiro de fondos como afiliado y otra como Beneficiario de Pensión en AFP PlanVital.'
          }
        },
        {
          ret_textos_formulario_id: {
            texto: 'Si eres pensionado y te encuentras en el periodo de renta temporal, el retiro se considerará en el próximo cálculo de anualidad y si no corresponde un nuevo recálculo, dependiendo del monto del retiro, podría implicar que te quedes algunos meses sin pensión, previo al inicio del pago de tu renta vitalicia.'
          }
        }
      ]
    }
  ]
};
